<script setup>
import { TabPanel } from '@headlessui/vue';
import { inject } from 'vue';
import ProgramDay from './ProgramDay.vue';

const programPackage = inject('programPackage');

const jumpToDate = (event, direction) => {
    const currentElement = document.querySelector(`#${event.currentId}`);
    const sibling = currentElement[`${direction}ElementSibling`];

    sibling.scrollIntoView({ behavior: 'smooth' });
};
</script>

<template>
    <TabPanel class="focus-visible:outline-deep-teal-700">
        <h2 class="text-2xl font-semibold text-deep-teal-700 pb-4">
            {{ $t('eventDetails.tabs.program') }}
        </h2>
        <div class="xl:w-9/12 space-y-4 md:space-y-8">
            <ProgramDay
                v-for="(items, startDate, index) in programPackage.program_items"
                :key="startDate"
                :program-items="items"
                :start-date
                :show-next-button="index !== Object.keys(programPackage.program_items).length - 1"
                :show-previous-button="index !== 0"
                @next-date-clicked="jumpToDate($event, 'next')"
                @previous-date-clicked="jumpToDate($event, 'previous')"
            />
        </div>
    </TabPanel>
</template>
